export default {
  setCursorX ({ commit }, payload) {
    commit('setCursorX', payload)
  }
}
